<ng-container *ngFor="let cb of serviceTicketStore.arrangedCallbacks$ | async">
  <vi-notification
    class="w-full min-w-full h-full min-h-full"
    data-at-callback-notification
    icon="headset_mic"
    layoutAlign="start"
    [shadow]="true"
    [dismissible]="true"
    (closed)="onClose(cb)"
    [@notification]
  >
    <ng-container *ngIf="authStore.getName() | async as userName">
      <ng-container [ngSwitch]="areWorkingHours(cb.time)">
        <div
          class="content"
          *ngSwitchCase="'yes'"
          [innerHTML]="
            '+SERVICE_APP.BAR.MESSAGE'
              | translate: { requester: userName, device: cb.device, id: cb.id }
              | trustHtml
          "
        ></div>
        <div
          class="content"
          *ngSwitchCase="'before'"
          [innerHTML]="
            '+SERVICE_APP.BAR.MESSAGE_BEFORE_WORKING_HOURS'
              | translate: { requester: userName, device: cb.device, id: cb.id }
              | trustHtml
          "
        ></div>
        <div
          class="content"
          *ngSwitchCase="'after'"
          [innerHTML]="
            '+SERVICE_APP.BAR.MESSAGE_AFTER_WORKING_HOURS'
              | translate: { requester: userName, device: cb.device, id: cb.id }
              | trustHtml
          "
        ></div>
      </ng-container>
    </ng-container>
  </vi-notification>
</ng-container>
